import { cn, generateRandomString } from "@/utils/string";
import { ChangeEvent, useState } from "react";
import toggleOn from "../../../../../../public/v3-assets/toggle-on.png";
import toggleOff from "../../../../../../public/v3-assets/toggle-off.png";

interface Props {
  type?: "email" | "text" | "password";
  placeholder?: string;
  value?: string;
  name?: string;
  handleChange: (text: string) => void;
  regex?: RegExp;
}
const AuthInput = ({
  type = "text",
  placeholder = "",
  value = "",
  name = generateRandomString(5),
  handleChange,
  regex,
}: Props) => {
  const [text, setText] = useState<string>(value);
  const [visible, setVisible] = useState(false);
  const [isError, setIsError] = useState(false);

  return (
    <div className="relative">
      <input
        name={name}
        onBlur={() => {
          if (regex) {
            setIsError(regex.test(text));
          }
        }}
        className={cn(
          `px-4 ${
            isError ? "border !border-red-400" : ""
          } h-10 outline-none  md:w-[600px]  rounded-[10px] ${
            text.length > 0 ? "bg-opacity-60" : "bg-opacity-50"
          } focus:bg-opacity-70 bg-white text-sm`,
        )}
        placeholder={value.length > 0 ? value : placeholder}
        type={!visible ? type : text}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const inputText = e.target.value;
          setText(inputText);
          handleChange(inputText);
        }}
      />
      {type == "password" && (
        <div className="h-10 absolute right-4 top-0">
          <button
            className="flex h-full flex-col justify-center items-center"
            onClick={() => setVisible(!visible)}
          >
            <img src={!visible ? toggleOff : toggleOn} alt="view password" />
          </button>
        </div>
      )}
    </div>
  );
};

export default AuthInput;
